// extracted by mini-css-extract-plugin
module.exports = {"offer":"styles_offer__YAYu5","button":"styles_button__1G8rk"};